import type { RouteObject } from "react-router";
// import { Navigate } from "react-router";
import { Component } from "./utils";

export function getFrontendDashboardRoutes(): RouteObject[] {
	const frontendDashboardRoutes: RouteObject[] = [
		{ path: "mining", element: Component("/pages/mining") },
		{ path: "mining/create-pool", element: Component("/pages/mining/create-pool") },
		{ path: "mining/pool/:id", element: Component("/pages/mining/pool-detail") },
		{ path: "staking", element: Component("/pages/staking") },
		{ path: "profile", element: Component("/pages/portfolio") },
		// { path: "https://fomo100.gitbook.io/fomo100-whitepaper/", element: "" },
	];

	return frontendDashboardRoutes;
}
